/**
 * Parse a YYYY-MM-DD date string as a local-timezone Date (not UTC).
 * `new Date('YYYY-MM-DD')` is parsed as UTC midnight per spec, which shifts
 * the displayed date by the user's UTC offset. Adding 'T00:00:00' forces
 * local-timezone interpretation.
 */
export const parseLocalDate = (str: string): Date => new Date(str + 'T00:00:00');
